export const newIntegration = ({ token }) => ({
  HTTPMethod: "get",
  path: "/api/v1/conduit/integrations/new",
  queryParams: {},
  headers: {
    Authorization: `Bearer ${token}`,
    Accept: "application/json",
    "Content-Type": "application/json",
  },
});
